module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        type: {
            type: 'string'
        },
        code: {
            type: 'string'
        },
        message: {
            type: 'string'
        },
        businessData: {
            type: 'string'
        },
        msgParameter1: {
            type: 'string'
        },
        msgParameter2: {
            type: 'string'
        },
        msgParameter3: {
            type: 'string'
        },
        msgParameter4: {
            type: 'string'
        }
    }
};